/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_MinimizeInputs */

const en_us2_workout_minimize = /** @type {(inputs: Workout_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimise the workout`)
};

const pt_br2_workout_minimize = /** @type {(inputs: Workout_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimizar o treino`)
};

const es_419_workout_minimize = /** @type {(inputs: Workout_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimizar el entrenamiento`)
};

const pt_pt2_workout_minimize = /** @type {(inputs: Workout_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimizar o treino`)
};

const fr_fr2_workout_minimize = /** @type {(inputs: Workout_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduire la séance`)
};

const de_de2_workout_minimize = /** @type {(inputs: Workout_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training minimieren`)
};

const it_it2_workout_minimize = /** @type {(inputs: Workout_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduci l'allenamento`)
};

/**
* | output |
* | --- |
* | "Minimise the workout" |
*
* @param {Workout_MinimizeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_minimize = /** @type {((inputs?: Workout_MinimizeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_MinimizeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_minimize(inputs)
	if (locale === "es-419") return es_419_workout_minimize(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_minimize(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_minimize(inputs)
	if (locale === "de-DE") return de_de2_workout_minimize(inputs)
	if (locale === "it-IT") return it_it2_workout_minimize(inputs)
	return en_us2_workout_minimize(inputs)
});
export { workout_minimize as "workout.minimize" }